// angular
// 	.module("HeroPRO")
//     .directive("windowResize", windowResizeDirective);

import _ from 'lodash';

/* @ngInject */
function windowResizeDirective($window, HPConfig, $rootScope) {
    return {
        restrict: 'A',
        link,
    };

    function link(scope) {
    // Listen for window resize events and use a debounce function so that
    // setScreenSize is only called 200ms after the window has finished resizing.
        const debouncedCheckWindow = _.debounce(() => {
        	setScreenSize();
        	scope.$apply();
    	}, 200);

        setScreenSize();
    	angular.element($window).bind('resize', debouncedCheckWindow);

    	function setScreenSize() {
    		$rootScope.screenSize = ($window.innerWidth >= HPConfig.screenSizes.screen_md) ? 'large' : 'small';
    	}
    }
}

export default angular.module('directives.windowResize', [])
    .directive('windowResize', windowResizeDirective)
    .name;



// WEBPACK FOOTER //
// ./src/app/common/windowResize/windowResizeDirective.js